import { Component } from 'react';

import './employees-list-item.css';

class EmployeesListItem extends Component {

  render() {

    let classNames = 'list-group-item d-flex justify-content-between';

    if (this.props.increase) {
      classNames += ' increase';
    };

    if (this.props.rise) {
      classNames += ' like';
    }

    return (
      <li className={classNames} >
        <span
          className="list-group-item-label"
          onClick={this.props.onToggle}
          data-toggle='rise'
        >{this.props.name}</span>
        <input onChange={this.props.onChangeSalary} type="text" name='salary' className="list-group-item-input" defaultValue={this.props.salary + '$'} />
        <div className='d-flex justify-content-center align-items-center'>
          <button type="button"
            onClick={this.props.onToggle}
            data-toggle='increase'
            className="btn-cookie btn-sm ">
            <i className="fas fa-cookie"></i>
          </button>

          <button type="button"
            onClick={this.props.onDeleteItem}
            className="btn-trash btn-sm ">
            <i className="fas fa-trash"></i>
          </button>
          <i className="fas fa-star"></i>
        </div>
      </li>
    )
  }
}

export default EmployeesListItem;
